<template>
  <Head title="Reimposta Password" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <h1 class="text-center text-2xl font-bold">Reimposta Password</h1>
          <p class="text-center text-sm text-gray-600 mt-2">
            Inserisci una nuova password per il tuo account.
          </p>
          <div class="mt-6 mx-auto w-24 border-b-2" />

          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="mt-10"
            label="Email"
            type="email"
            autofocus
            autocapitalize="off"
          />

          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="mt-6"
            label="Nuova Password"
            type="password"
          />

          <text-input
            v-model="form.password_confirmation"
            :error="form.errors.password_confirmation"
            class="mt-6"
            label="Conferma Password"
            type="password"
          />

          <p class="text-xs text-gray-500 mt-2">
            La password deve essere di almeno 8 caratteri.
          </p>
        </div>
        <div class="flex items-center justify-between px-10 py-4 bg-gray-100 border-t border-gray-100">
          <Link href="/login" class="text-sm text-indigo-600 hover:text-indigo-800 underline">
            Torna al Login
          </Link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Reimposta Password
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import LoadingButton from "@/Pages/Dashboard/Shared/LoadingButton";
import Logo from "@/Pages/Dashboard/Shared/Logo";
import TextInput from "@/Pages/Dashboard/Shared/TextInput";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    Logo,
    TextInput,
  },
  props: {
    token: String,
    email: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email || "",
        password: "",
        password_confirmation: "",
      }),
    };
  },
  methods: {
    submit() {
      this.form.post("/reset-password");
    },
  },
};
</script>
